import React from "react";

interface ComingSoonBannerProps {
  title?: string;
  subtitle?: string;
}

/**
 * ComingSoonBanner - Banner for features that are coming soon
 * Features purple gradient background with brutalist styling
 */
const ComingSoonBanner: React.FC<ComingSoonBannerProps> = ({
  title = "Coming Soon",
  subtitle = "This feature is currently in development",
}) => {
  return (
    <div className="su-coming-soon-banner">
      {/* Gradient overlay for depth */}
      <div className="su-coming-soon-banner-gradient" />

      {/* Content */}
      <div className="su-coming-soon-banner-inner">
        <div className="su-coming-soon-banner-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <div className="su-coming-soon-banner-content">
          <div className="su-coming-soon-banner-title">{title}</div>
          <div className="su-coming-soon-banner-subtitle">{subtitle}</div>
        </div>
        <div className="su-coming-soon-banner-badge">COMING SOON</div>
      </div>
    </div>
  );
};

export default ComingSoonBanner;
